import React from "react";
import { useState, useContext } from "react";
import { useHistory } from "react-router-dom";
import { NotificationAlertContext } from "contexts/notificationAlertContext";
import ReactTable from "components/ReactTable/ReactTableWithDynamicPagination";
import SweetAlert from "react-bootstrap-sweetalert";
import _ from "lodash";
// react-bootstrap components
import {
  Button,
  Card,
  Form,
  Container,
  Row,
  Col,
  Spinner,
  Table,
} from "react-bootstrap";
import {
  addClient,
  getKeygenClientSearch,
  addLicense,
} from "graphql/queries.js";
import { API, graphqlOperation } from "aws-amplify";

function ActivateClient(props) {
  // Contexts
  const history = useHistory();
  const notify = useContext(NotificationAlertContext);

  const [disableFields, setDisableFields] = useState(false);

  const [showLoader, setShowLoader] = useState(false);
  const [selectedClient, setSelectedClient] = useState(null);
  const [selectedSAP, setSelectedSAP] = useState(null);
  const [selectedLicense, setSelectedLicense] = useState(null);
  const [clientDetails, setClientDetails] = useState([]);
  const [keygenLicenseArray, setKeygenLicenseArray] = useState([]);
  const [alert, setAlert] = useState(null);

  // Pagination Starts

  const headers = [
    { key: "keygen_customer_id", label: "SAP ID" },
    { key: "keygen_customer_name", label: "Client Name" },
    { key: "keygen_name", label: "Keygen Name" },
    { key: "keygen_key", label: "Keygen Key" },
  ];

  const columnMapping = {
    "SAP ID": "keygen_customer_id",
    "Client Name": "keygen_customer_name",
    "Keygen Name": "keygen_name",
    "Keygen Key": "keygen_key",
  };

  const [totalCount, setTotalCount] = useState(0);
  const numberOfRowsData = [25, 50, 100];

  const [currentLimit, setCurrentLimit] = useState(numberOfRowsData[0]);
  const [currentOffset, setCurrentOffset] = useState(0);
  const [ascOrDescValue, setAscOrDescValue] = useState("ASC");
  const [sortValue, setSortValue] = useState("Channel Name");

  const [clientId, setClientId] = useState("");
  const addLicenseProps = props.addLicense;

  const setStateForPagnination = async (key, value) => {
    if (key === "currentLimit") {
      setCurrentLimit(value);
    } else if (key === "offset") {
      setCurrentOffset(value);
    } else if (key === "ascOrDesc") {
      setAscOrDescValue(value);
    } else {
      setSortValue(value);
    }
  };
  // Pagination Ends

  const createClient = async () => {
    try {
      setShowLoader(true);
      const clientLicenseValues = clientDetails.find((x) => {
        return keygenLicenseArray.includes(x.keygen_key);
      });
      if (!clientLicenseValues) {
        notify("warning", "Select a client to activate");
        return;
      }
      setAlert(
        <SweetAlert
          showCancel
          title={`${clientLicenseValues.keygen_customer_name} will be created as a client.  All licenses with the same SAP_ID will be added to this client.`}
          onConfirm={async () => {
            setAlert(null);
            const params = {
              sap_id: clientLicenseValues.keygen_customer_id,
              client_name: clientLicenseValues.keygen_customer_name,
              keygen_id: clientLicenseValues.keygen_id,
              keygen_key: clientLicenseValues.keygen_key,
              keygen_name: clientLicenseValues.keygen_name,
            };
            const response = await API.graphql(
              graphqlOperation(addClient, params)
            );
            if (response.data?.addClient?.success) {
              setDisableFields(true);
              notify("success");
              const newClientId = _.get(
                response,
                "data.addClient.body.client_id"
              );
              const entitlementUrl = `/admin/clients/${newClientId}/manage-licensing/manage-entitlements`;
              history.push(entitlementUrl);
            } else {
              setDisableFields(false);
              console.error(response.data?.addClient?.message);
              notify("danger");
            }
          }}
          onCancel={() => setAlert(null)}
          confirmBtnBsStyle="primary"
          cancelBtnBsStyle="danger"
          confirmBtnText="Confirm"
          cancelBtnText="Cancel"
        ></SweetAlert>
      );
    } catch (error) {
      setDisableFields(false);
      console.error(error);
      notify("danger");
    } finally {
      setShowLoader(false);
    }
  };
  const functionKeygenConfirm = async (clientLicenseValues) => {
    try {
      props.setShowLoader(true);
      const params = {
        client_id: props.clientId,
        license_details: JSON.stringify(clientLicenseValues),
      };
      const response = await API.graphql(graphqlOperation(addLicense, params));
      if (response.data?.addLicense?.success) {
        setDisableFields(true);
        notify("success", "License successfully added");
        props.fetchPageData();
      } else {
        setDisableFields(false);
        console.error(response.data?.addLicense?.message);
        notify("danger", "License was not added successfully");
      }
    } catch (error) {
      console.error(error);
      notify("danger", "License was not added successfully");
    } finally {
      props.setShowLoader(false);
    }
  };
  const callKeygenConfirm = async (clientLicenseValues) => {
    setAlert(
      <SweetAlert
        showCancel
        title={`The license selected belongs to a different SAP Id do you still want to continue?`}
        style={{ overflow: "scroll", display: "block" }}
        onConfirm={async () => {
          setAlert(null);
          functionKeygenConfirm(clientLicenseValues);
        }}
        onCancel={() => setAlert(null)}
        confirmBtnBsStyle="primary"
        cancelBtnBsStyle="danger"
        confirmBtnText="Confirm"
        cancelBtnText="Cancel"
      ></SweetAlert>
    );
  };
  const addLicenses = async () => {
    try {
      const clientLicenseValues = clientDetails.filter((x) => {
        return keygenLicenseArray.includes(x.keygen_key);
      });
      setAlert(
        <SweetAlert
          showCancel
          title={`Do you want to add below licenses to ${props.clientName}?`}
          style={{ overflow: "scroll", display: "block" }}
          onConfirm={async () => {
            setAlert(null);
            if (
              !clientLicenseValues.some(
                (license) => license["keygen_customer_id"] === props.clientId
              )
            ) {
              callKeygenConfirm(clientLicenseValues);
            } else {
              functionKeygenConfirm(clientLicenseValues);
            }
          }}
          onCancel={() => setAlert(null)}
          confirmBtnBsStyle="primary"
          cancelBtnBsStyle="danger"
          confirmBtnText="Confirm"
          cancelBtnText="Cancel"
        >
          <Table className="table-hover table-striped w-full">
            <tr>
              <th>Sl.No</th>
              <th>Keygen Name</th>
              <th>Keygen Key</th>
            </tr>
            <tbody>
              {clientLicenseValues.map((x, i) => {
                return (
                  <tr>
                    <td>{i + 1}</td>
                    <td>{x.keygen_name}</td>
                    <td>{x.keygen_key}</td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </SweetAlert>
      );
    } catch (error) {
      setDisableFields(false);
      console.error(error);
      notify("danger");
    }
  };

  const getKeygenClientSearchDetails = async (
    variables = {},
    isCSVDownload = false
  ) => {
    try {
      if (!selectedClient && !selectedSAP && !selectedLicense) {
        notify(
          "warning",
          "Enter one field at least to search for license details"
        );
        return;
      }
      setShowLoader(true);

      const response = await API.graphql(
        graphqlOperation(getKeygenClientSearch, {
          client_name: selectedClient || undefined,
          sap_id: selectedSAP || undefined,
          mc_license_key: selectedLicense || undefined,
          limit: variables.limit,
          offSet: variables.offSet,
          sortFilter: variables.sortFilter,
          sortType: variables.sortType,
        })
      );
      if (response.data?.getKeygenClientSearch?.success) {
        if (!isCSVDownload) {
          const data = response.data?.getKeygenClientSearch?.body;
          if (!data.keygen_client_search_data.length) {
            notify(
              "warning",
              "No clients data found that are currently not activated."
            );
            setShowLoader(false);
            return;
          }
          setClientDetails(data.keygen_client_search_data);
          setTotalCount(data.total_count);
          notify("success");
          setShowLoader(false);
          return true;
        } else {
          const filter = {
            "Client ID": selectedClient,
            "SAP Id": selectedSAP,
            "MC License Key": selectedLicense,
          };
          const messageDataForCSV = _.get(
            response,
            "data.getKeygenClientSearch.body.keygen_client_search_data"
          );
          return { messageDataForCSV, filter };
        }
      } else {
        console.error(response.data?.getKeygenClientSearch?.message);
        notify("danger");
        setShowLoader(false);
        return false;
      }
    } catch (error) {
      console.error(error);
      setShowLoader(false);
      notify("danger");
      return false;
    }
  };

  if (showLoader) return <Spinner animation="grow" />;

  return (
    <>
      {alert}
      <Container fluid>
        <Row>
          <Col>
            <h2>Activate Client</h2>
          </Col>
          {clientDetails && clientDetails.length > 0 && (
            <Col className="my-auto text-right">
              <Button
                variant="primary"
                onClick={() => {
                  if (!addLicenseProps) {
                    createClient();
                  } else {
                    addLicenses();
                  }
                }}
              >
                <i className="fas fa-plus"></i> Activate Client
              </Button>
            </Col>
          )}
        </Row>
        <Row>
          <Col>
            <Card>
              <Card.Header>
                <Card.Title>Keygen Client Search</Card.Title>
              </Card.Header>
              <Card.Body>
                <Form noValidate>
                  <Row className="align-items-end">
                    <Col md="3">
                      <label>Search by Client Name</label>
                      <Form.Control
                        name="keygenClientName"
                        type="text"
                        value={selectedClient}
                        onChange={(e) => {
                          setSelectedClient(e.target.value);
                        }}
                        placeholder="Enter Client Name"
                        disabled={disableFields}
                        required
                      />
                    </Col>
                    <Col md="3">
                      <label>Search by SAP Id</label>
                      <Form.Control
                        type="text"
                        value={selectedSAP}
                        onChange={(e) => {
                          setSelectedSAP(e.target.value);
                        }}
                        placeholder="Enter SAP Id"
                        disabled={disableFields}
                        required
                      />
                    </Col>
                    <Col md="3">
                      <label>Search by MC License Key</label>
                      <Form.Control
                        type="text"
                        value={selectedLicense}
                        onChange={(e) => setSelectedLicense(e.target.value)}
                        placeholder="Enter License Key"
                        disabled={disableFields}
                        required
                      />
                    </Col>
                    {!disableFields && (
                      <Col md="3">
                        <Button
                          variant="primary"
                          onClick={() => {
                            getKeygenClientSearchDetails();
                          }}
                        >
                          Search
                        </Button>
                      </Col>
                    )}
                  </Row>
                </Form>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        {clientDetails && clientDetails.length > 0 && (
          <>
            <Row>
              <Col>
                <ReactTable
                  data={clientDetails}
                  totalCount={totalCount}
                  functionCallBack={getKeygenClientSearchDetails}
                  setStateForPagnination={setStateForPagnination}
                  currentLimit={currentLimit}
                  currentOffset={currentOffset}
                  ascOrDescValue={ascOrDescValue}
                  sortValue={sortValue}
                  numberOfRowsData={numberOfRowsData}
                  columnMapping={columnMapping}
                  tableName="Keygen Clients"
                  CSVFileName="Keygen_Client_Export"
                  CSVHeaders={headers}
                  notify={notify}
                  columns={[
                    {
                      Header: "Select",
                      Cell: (cell) => {
                        const row = cell.row.original;
                        return (
                          <input
                            type={addLicenseProps ? "checkbox" : "radio"}
                            className="form-control"
                            value={row.keygen_key}
                            defaultChecked={keygenLicenseArray.includes(
                              row.keygen_key
                            )}
                            onChange={(event) => {
                              if (!addLicenseProps) {
                                setKeygenLicenseArray([event.target.value]);
                                setClientId(row.keygen_customer_id);
                              } else {
                                setClientId(null);
                                let keygenLicense = keygenLicenseArray;
                                if (
                                  !event.target.checked &&
                                  keygenLicense.includes(row.keygen_key)
                                ) {
                                  const idempotencyIndex =
                                    keygenLicense.findIndex((x) => {
                                      return x === row.keygen_key;
                                    });
                                  keygenLicense.splice(idempotencyIndex, 1);
                                }
                                if (
                                  !keygenLicenseArray.includes(
                                    row.keygen_key
                                  ) &&
                                  event.target.checked
                                ) {
                                  keygenLicense.push(row.keygen_key);
                                }
                                setKeygenLicenseArray(keygenLicense);
                              }
                            }}
                          />
                        );
                      },
                      filterable: false,
                      showTooltip: false,
                      sortable: false,
                      maxWidth: 80,
                    },
                    {
                      Header: "SAP ID",
                      accessor: "keygen_customer_id",
                      showTooltip: true,
                    },
                    {
                      Header: "Client Name",
                      accessor: "keygen_customer_name",
                      showTooltip: true,
                    },
                    {
                      Header: "Keygen Name",
                      accessor: "keygen_name",
                      showTooltip: true,
                    },
                    {
                      Header: "Keygen Expiry",
                      accessor: "keygen_expiry",
                      showTooltip: true,
                    },
                    {
                      Header: "Keygen Key",
                      accessor: "keygen_key",
                      showTooltip: true,
                    },
                  ]}
                />
              </Col>
            </Row>
          </>
        )}
      </Container>
    </>
  );
}

export default ActivateClient;
